import { State } from 'interfaces/state'
import CreditPage, { CreditPageProps } from 'components/features/pfm/CreditPage/CreditPage'
import { timeframeSelector, memberInfoSelector } from 'selectors/globalSelectors'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import internal from 'components/utils/Internal'
import { Guards } from 'interfaces/guards'
import { linkedMixedAccountsGuard } from 'guards/linkageGuards'
import { connectShadedLoadable } from 'helpers/loadableHelpers'

const mapStateToProps = (state: State): CreditPageProps => {
  const member = memberInfoSelector(state)
  if (!member) {
    // it's rendered under InternalPageGuard, so we can afford to just `connect`
    throw createForgottenGuardError('CreditContainer', 'memberInfoGuard')
  }

  return {
    timeframe: timeframeSelector(state, { type: 'creditscore' }),
    isCreditFileLinked: member.is_creditfile_linked,
  }
}

const guards: Guards<{}> = [
  linkedMixedAccountsGuard,
]

const Connected = connectShadedLoadable<
CreditPageProps
>(mapStateToProps, undefined, guards)(CreditPage)

const ConnectedInternal = internal(Connected)
export default ConnectedInternal
